import { render } from "./CoreDataView.vue?vue&type=template&id=626428cd&lang=true"
import script from "./CoreDataView.vue?vue&type=script&lang=js"
export * from "./CoreDataView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__